














import { Component, Model, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({})
export default class CodeForm extends Vue {
  @State("codes")
  private text!: string;

  @Action("updateCodes")
  private update!: (codes: string) => void;
}
